<template>
  <div class="w-full">
    <div class="grid w-full grid-cols-12 px-16 py-16 mb-12 border rounded-md border-light-gray-4">
      <div class="col-span-3">
        <img class="object-cover object-center rounded-md w-80 h-80 bg-light-gray-4" :src="artwork.images.profileImage['sm']" :alt="artwork.images.altImage"/>
      </div>
      <div class="grid items-center col-span-8 ml-10 mr-24 md:ml-0 w-fit">
        <a :href="artwork.url">
          <p class="font-bold text-14 lg:text-16 text-orange">
            {{ artwork.title }}
          </p>
        </a>
        <p class="text-12 lg:text-14">
          {{ artwork.artist.name }}
        </p>
        <p class="font-bold text-12 lg:text-14">
          {{ artwork.priceWithCurrency }}
        </p>
      </div>
      <div class="grid items-center justify-center col-span-1">
        <AddToCartButton mini :artwork="item" :status="item.status.toLowerCase()" @added="item.status = 'reserved'"/>
      </div>
    </div>
  </div>
</template>

<script>
import AddToCartButton from '../../Universal/AddToCartButton.vue';

export default {
  components: { AddToCartButton },

  props: {
    artwork: {
        type: Object,
        required: true,
    },
  },

  data () {
    return {
      item: {},
    }
  },

  created() {
    this.item = this.artwork
  }
}
</script>
